// extracted by mini-css-extract-plugin
export default {"groupButton":"group-button_groupButton__Y8O4X","groupButtonNoIcon":"group-button_groupButtonNoIcon__uzFUc"};